import React, { useEffect, useState } from 'react'
import { api_url, titleDescription } from '../../config/Config';
import { Table } from 'react-bootstrap';
import ReplayIcon from "@mui/icons-material/Replay";
import _fetch from '../../config/api';
import dateformat from "dateformat";
import { useParams } from 'react-router-dom';
import { ColorRing } from 'react-loader-spinner';
import ReactPaginate from "react-paginate";
import { useTranslation } from 'react-i18next';

const PayoutSummary = (props: any) => {
    const { t, i18n } = useTranslation();
    const { type } = useParams();

    useEffect(() => {
        document.title = `${props.pageTitle} | ${titleDescription}`;
    });

    const [payoutData, setPayoutData] = useState([]);
    const [totalRecord, setTotalRecord] = useState(0);
    const [result, setResult] = useState(0);
    const [totalAmount, setTotalAmount] = useState(0);
    const [loading, setLoading] = useState(true);
    const [page, setpage] = useState(1);
    const [levelSearch, setLevelSearch] = useState('');
    const [searchedType, setSearchType] = useState('level');
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [limit, setLimit] = useState(10);
    const [keyCount, setKeycount] = useState(0);
    const [types, setTypes] = useState(['deposit_bonus_income', 'profit_sharing_income', 'level_income', 'ib_commission_income', 'salary_income']);
    const [allLevels, setAllLevels] = useState([
        1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20
    ]);

    useEffect(() => {
        getIncomeReport();

    }, [levelSearch, page, type, limit]);

    useEffect(() => {
        setStartDate('');
        setEndDate('')
    }, [type]);

    const getIncomeReport = async () => {
        setLoading(true);
        if (levelSearch) {
            if (startDate) {
                var searchData = `&startDate=${startDate}&endDate=${endDate}&level=${levelSearch}`;

            } else {
                var searchData = `&level=${levelSearch}`;
            }
        } else {
            var searchData = "";
        }
        if (startDate) {
            var searchData = `&startDate=${startDate}&endDate=${endDate}`;

        } else {
            var searchData = "";
        }

        let res = await _fetch(`${api_url}report/payout-summary?limit=${limit}&page=${page}${searchData}`, "GET", {})
        if (res?.status === "success") {
            setLoading(false);
            setPayoutData(res?.data);
            setTotalRecord(res?.total);
            setResult(res?.results);
            setTotalAmount(res?.totalAmount);
        }
        if (page > 1) {
            setKeycount(0);
            var count = page - 1;
            setKeycount(count * limit);
        }
    }

    const handlePageClick = async (event: any) => {
        const newOffset = (event.selected + 1);
        setpage(newOffset);
    };

    const refresh = () => window.location.reload();

    return (
        <main>
            <div className="uni-level-outer">
                <div className="coustom_container">
                    <div className="level_inner loader_main">
                        {loading &&
                            <div className="spinner_bg">
                                <div className="color_ring">  <ColorRing
                                    visible={true}
                                    height="80"
                                    width="80"
                                    ariaLabel="blocks-loading"
                                    wrapperStyle={{}}
                                    wrapperClass="blocks-wrapper"
                                    colors={['#2b3892', '#2b3892', '#2b3892', '#2b3892', '#2b3892']}
                                /></div>
                            </div>
                        }
                        <div className="table_section">
                            <div className="scrolling_table">
                                <div className="scroll_under">
                                    <Table className="support_table">
                                        <thead>
                                            <tr className="table_heading_row">
                                                <th className="table_heading"> #</th>
                                                <th className="table_heading">{t("Date")}</th>
                                                {types.map((type, i) => (
                                                    <th key={i} className="table_heading">
                                                        {type.replace(/_/g, ' ').split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}
                                                    </th>
                                                ))}
                                                <th className="table_heading">{t("Total Payout")}</th>
                                                <th className="table_heading">{t("Action")}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {payoutData?.map((item: any, index: any) => {
                                                return (
                                                    <>
                                                        <tr className="table_data_row">
                                                            <td className="table_data">{page > 1 ? index + keyCount + 1 : index + 1}</td>
                                                            <td className="table_data">{item?.date}</td>
                                                            {types.map((type, i) => (
                                                                <td className="table_data" key={i}>${item.incomes[type]?.toFixed(2) || 0}</td>
                                                            ))}
                                                            <td className="table_data">{item?.total_amount?.toFixed(2)}</td>
                                                            <td className="table_data"><a className='vie-btn' href={`/datewise-summary/${item.date}`}>View</a></td>
                                                        </tr>
                                                    </>
                                                )
                                            })}
                                        </tbody>
                                    </Table>
                                    {totalRecord > 10 && <ReactPaginate className="pagination__2 " activeClassName="active"
                                        breakLabel="..."
                                        nextLabel=">"
                                        onPageChange={handlePageClick}
                                        pageRangeDisplayed={1}
                                        pageCount={totalRecord / 10}
                                        previousLabel="<"
                                    />}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    )
}

export default PayoutSummary